import React, { memo } from 'react'
import CircularProgress from '@alobato/circular-progress'
import { Formik } from 'formik'
import * as Yup from 'yup'
import '../../validators'

import FormModal from '../../components/FormModal'
import Form from './Form'
import useCatalogos from '../../hooks/useCatalogos'
import { enviarCadastro } from '../../lib/enviarCadastro'

import BASE_API from '../../constants/baseApi'

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  login: Yup.string().email().required(),
  password: Yup.string().min(6).required(),
  comercial_email: Yup.string().email('E-mail inválido'),
  website: Yup.string().url('Endereço inválido — comece com https://')
})

/* Clínica nova já nasce visível na busca: cadastrar e não aparecer para o
   paciente é o tipo de padrão que só se descobre depois de alguém reclamar. */
const New = ({ onRequestClose, onCreated, especialidades, planos }) => {
  const initialValues = {
    name: '', login: '', password: '',
    comercial_email: '', phone: '', whatsapp: '', website: '',
    working_time: '', small_description: '', description: '',
    has_exam: true, has_schedule: false, has_schedule_exam: false,
    need_login: false, visible: true,
    specialties: [], health_insurances: []
  }

  const handleSubmit = async (values, actions) => {
    const salvou = await enviarCadastro({
      url: `${BASE_API}/establishment/`, method: 'POST', values, actions
    })
    if (!salvou) return
    onCreated()
    onRequestClose()
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      validateOnChange={false}
      render={props => (
        <FormModal title='Novo Estabelecimento' onRequestClose={onRequestClose}
          onSubmit={props.handleSubmit} submitting={props.isSubmitting} error={props.status}>
          <Form {...props} isCreating especialidades={especialidades} planos={planos} />
        </FormModal>
      )}
    />
  )
}

export default memo(props => {
  const catalogos = useCatalogos()
  if (catalogos.carregando) return <CircularProgress color='hsla(199, 75%, 43%, 1)' />
  return (
    <New {...props}
      especialidades={catalogos.especialidades} planos={catalogos.planos} />
  )
})
